import { IAuthResponse } from '../types/api'
import { moment } from './moment'

const NAME_TOKEN_FIELD = 'jwt_token'
const NAME_REFRESH_TOKEN_FIELD = 'refresh_token'
const NAME_DATE_FIELD = 'login_date'

export function setAuth(data: IAuthResponse) {
    localStorage.setItem(NAME_TOKEN_FIELD, data.token)
    localStorage.setItem(NAME_REFRESH_TOKEN_FIELD, data.refreshToken)
    localStorage.setItem(NAME_DATE_FIELD, moment().format())
}

export function removeAuth() {
    localStorage.removeItem(NAME_TOKEN_FIELD)
    localStorage.removeItem(NAME_REFRESH_TOKEN_FIELD)
    localStorage.removeItem(NAME_DATE_FIELD)
}

export function getJWT() {
    return localStorage.getItem(NAME_TOKEN_FIELD)
}

export function getLoginDate() {
    return localStorage.getItem(NAME_DATE_FIELD)
}

export function getRefreshToken() {
    return localStorage.getItem(NAME_REFRESH_TOKEN_FIELD)
}
